import React from 'react';

import EventsRegisterSearchRoute from 'routes/Events/RegisterSearch';
import EventsOrdersRoute from 'routes/Events/Orders';
import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/:id',
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'eventsBikeClassesInfo' */ './component')],
			render: ([EventsBikeClassesInfo]) => <EventsBikeClassesInfo />,
		},
		{
			path: '/reservation',
			components: () => [
				import(/* webpackChunkName: 'eventsBikeClassesReservation' */ './reservation'),
			],
			render: ([EventsBikeClassesReservation]) => <EventsBikeClassesReservation />,
		},
		EventsRegisterSearchRoute,
		EventsOrdersRoute,
	],
};

export default routes;
